import React, { useState } from "react";
import { FiArrowLeft, FiCamera, FiExternalLink, FiFile, FiFileText, FiImage } from "react-icons/fi";
import { FileInput, Logo, Toast } from "../../Components";
import { apis } from "../../Utils/axios";

function MobileStore() {
	const Params = new URLSearchParams(window.location.search);
	const [UploadFiles, setUploadFiles] = useState([]);
	const returnToParam = Params.get("returnTo");
	const hasSafeReturn = returnToParam && returnToParam.startsWith("/");
	const returnTo = hasSafeReturn ? returnToParam : "/app/expense/";
	const isPdfFile = (file = {}) => {
		const name = `${file?.name || ""}`.toLowerCase();
		const url = `${file?.url || ""}`.toLowerCase();
		const mime = `${file?.mimeType || file?.mimetype || file?.type || ""}`.toLowerCase();
		return mime.includes("pdf") || name.endsWith(".pdf") || url.includes(".pdf");
	};
	const isImageFile = (file = {}) => {
		const name = `${file?.name || ""}`.toLowerCase();
		const url = `${file?.url || ""}`.toLowerCase();
		const mime = `${file?.mimeType || file?.mimetype || file?.type || ""}`.toLowerCase();
		return mime.startsWith("image/") || [".jpg", ".jpeg", ".png", ".webp", ".gif"].some((ext) => name.endsWith(ext) || url.includes(ext));
	};

	const goBackToApp = () => {
		const uploadedCount = Math.max(UploadFiles.length, 1);
		const separator = returnTo.includes("?") ? "&" : "?";
		window.location.href = `${returnTo}${separator}receiptUploaded=${uploadedCount}&openAddReceipt=1`;
	};

	const onSelect = (obj) => {
		Toast.success("File uploaded");
		setUploadFiles((prev) => [...prev, obj.file]);
	};

	return (
		<div className="fixed top-0 bottom-0 left-0 right-0 overflow-x-hidden overflow-y-auto bg-light">
			<div className="min-h-full p-5 flex-center">
				<div className="w-full max-w-md p-5 border shadow-sm rounded-2xl bg-canvas border-surface">
					<button onClick={goBackToApp} className="btn btn-light btn-sm mb-4 gap-2 w-full">
						<FiArrowLeft /> Back to App
					</button>
					<Logo className="mb-4 flex-center" />
					<div className="mb-4 text-center">
						<h3>Receipt Upload</h3>
						<div className="mt-1 text-xs text-secondary">Upload receipt image or PDF to your corporate receipt store</div>
					</div>
					<div className="p-3 mb-4 text-xs rounded-lg bg-light text-secondary">Supported files: JPG, PNG, PDF</div>
					<FileInput url={apis.addInStore} data={{ code: Params.get("code") }} multiple extensions={[".jpg", ".jpeg", ".png", ".pdf"]} onUpload={(obj) => onSelect(obj)}>
						<div className="w-full gap-3 p-4 text-base text-white bg-primary flex-center rounded-xl">
							<FiCamera /> Upload File
						</div>
					</FileInput>
					{UploadFiles.length > 0 && (
						<div className="mt-5 text-center">
							<div className="inline-block px-3 py-1 mb-3 text-xs rounded-full bg-success text-successText">{UploadFiles.length} Uploaded</div>
							<div className="space-y-2 text-left max-h-44 overflow-y-auto">
								{UploadFiles.map((file, i) => {
									const url = file?.url || "";
									const isPdf = isPdfFile(file);
									const isImage = isImageFile(file);
									const name = file?.name || `Uploaded file ${i + 1}`;
									const typeLabel = isPdf ? "PDF document" : isImage ? "Image receipt" : "File";
									return (
										<a key={i} href={url} target="_blank" rel="noreferrer" className="flex items-center gap-3 p-2 border rounded-lg bg-light border-surface hover:bg-whitish">
											{isImage ? (
												<img src={url} alt={name} className="object-cover rounded-md w-10 h-10" />
											) : (
												<div className="w-10 h-10 rounded-md flex-center bg-canvas border border-surface">
													{isPdf ? <FiFileText className="text-dangerText" /> : <FiFile className="text-secondary" />}
												</div>
											)}
											<div className="flex-1 min-w-0">
												<div className="text-xs font-semibold truncate">{name}</div>
												<div className="text-xxs text-secondary flex items-center gap-1">
													{isPdf ? <FiFileText /> : isImage ? <FiImage /> : <FiFile />} {typeLabel}
												</div>
											</div>
											<FiExternalLink className="text-secondary" />
										</a>
									);
								})}
							</div>
							<div className="mt-3 text-xs text-secondary">You can return to the app and continue reimbursement submission.</div>
							<button onClick={goBackToApp} className="btn btn-primary btn-sm w-full mt-4">
								Return to Expense
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default MobileStore;
